import { LocalDate } from '@js-joda/core';

import { ModalConfirmButton } from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../translations';
import { InvoicePaymentMethod } from '../types';

import { useCompanyInvoiceCreateCommand } from './CompanyInvoiceCreateModalConfirmButton.hooks';
import { InvoiceCreateFormController } from './form/InvoiceCreateForm.types';

type CompanyInvoiceCreateModalConfirmButtonProps = Pick<InvoiceCreateFormController, 'handleSubmit'> & {
   readonly paymentMethod: InvoicePaymentMethod;
   readonly visitDate: LocalDate;
   readonly onClose: VoidFunction;
   readonly visitSettlementId: number;
   readonly receiptAvailableForInvoice: boolean;
};

export const CompanyInvoiceCreateModalConfirmButton = (
   props: CompanyInvoiceCreateModalConfirmButtonProps
): JSX.Element => {
   const { executeAsync: createCompanyInvoice } = useCompanyInvoiceCreateCommand({
      onSuccess: props.onClose,
      paymentMethod: props.paymentMethod.type,
      paymentMethodDescription: props.paymentMethod.description,
      visitDate: props.visitDate,
      visitSettlementId: props.visitSettlementId,
      receiptAvailableForInvoice: props.receiptAvailableForInvoice,
   });

   return (
      <ModalConfirmButton
         testId={'companyInvoiceCreateModalConfirmButton'}
         label={invoiceCreateModalTranslationKeys.confirmButtonLabel}
         onClick={props.handleSubmit(createCompanyInvoice)}
      />
   );
};
